var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "conteneurLead",
      staticStyle: { width: "100%" },
      attrs: { flat: "", id: "conteneurLead" }
    },
    [
      _c(
        "v-card-title",
        {
          staticClass: "primary white--text",
          staticStyle: { height: "52px", padding: "0px" }
        },
        [
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("justCloseDialogConfirm")
                }
              }
            },
            [_c("v-icon", { staticClass: "white--text" }, [_vm._v("close")])],
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "title tf_title_dialog",
            domProps: { innerHTML: _vm._s(_vm.titleDialogConfirm) }
          }),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.$vuetify.breakpoint.smAndDown
            ? _c(
                "v-btn",
                {
                  staticClass: "white--text",
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.submitDialogConfirm()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("submit")))]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "", "justify-space-between": "" } },
            [
              _c("v-flex", { attrs: { xs12: "" } }, [
                !_vm.loadingRes && !_vm.contentDialogRes.length
                  ? _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.contentDialogConfirm) }
                    })
                  : _c("div", { staticClass: "tf_loading_url" }, [
                      _c("div", { staticClass: "tf_contentLoading" }, [
                        _vm.loadingRes
                          ? _c(
                              "div",
                              { staticClass: "text-xs-center" },
                              [
                                _c(
                                  "v-progress-circular",
                                  {
                                    attrs: {
                                      rotate: -90,
                                      size: 120,
                                      width: 8,
                                      value: _vm.loadingValue,
                                      color: "primary"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t  \t\t\t\t" +
                                        _vm._s(_vm.loadingValue) +
                                        " %\n\t\t\t  \t\t\t"
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.contentDialogRes.length
                          ? _c("div", { staticClass: "tf_contentLoadingTxt" }, [
                              _c("div", {
                                staticClass: "contentLoading",
                                domProps: {
                                  innerHTML: _vm._s(_vm.contentDialogRes)
                                }
                              })
                            ])
                          : _vm._e()
                      ])
                    ])
              ]),
              _vm._v(" "),
              !_vm.contentDialogRes.length
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("p", [_c("v-spacer")], 1),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c("p", [_c("v-spacer")], 1)
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.contentDialogRes.length
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("chooseprompt")) +
                          " :"
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          items: _vm.computedActionUrl,
                          "item-text": "text",
                          "item-value": "id"
                        },
                        on: {
                          change: function($event) {
                            return _vm.actionsPrompt()
                          }
                        },
                        model: {
                          value: _vm.selectActionPrompt,
                          callback: function($$v) {
                            _vm.selectActionPrompt = $$v
                          },
                          expression: "selectActionPrompt"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "", "justify-space-between": "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-layout",
                    { staticClass: "mb-3", attrs: { row: "", wrap: "" } },
                    [
                      _c("v-flex", { attrs: { xs12: "", md3: "" } }, [
                        _c(
                          "div",
                          { staticClass: "search-block" },
                          [
                            _c("v-text-field", {
                              attrs: {
                                "append-icon": "search",
                                label: _vm.$t("filtername"),
                                clearable: ""
                              },
                              model: {
                                value: _vm.searchName,
                                callback: function($$v) {
                                  _vm.searchName = $$v
                                },
                                expression: "searchName"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "pl-2", attrs: { xs12: "", md2: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                small: "",
                                color: _vm.showFilters ? "primary" : "",
                                outline: !_vm.showFilters
                              },
                              on: {
                                click: function($event) {
                                  _vm.showFilters = !_vm.showFilters
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("filtersprompt")) +
                                  "\n                      "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showFilters
                    ? _c(
                        "v-layout",
                        { staticClass: "mb-3", attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md4: "" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.authorOptions,
                                  label: _vm.$t("filterauthor"),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.selectedAuthor,
                                  callback: function($$v) {
                                    _vm.selectedAuthor = $$v
                                  },
                                  expression: "selectedAuthor"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md4: "" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.llmOptions,
                                  label: _vm.$t("filterllm"),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.selectedLlm,
                                  callback: function($$v) {
                                    _vm.selectedLlm = $$v
                                  },
                                  expression: "selectedLlm"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md4: "" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.dateRangeOptions,
                                  label: _vm.$t("filterdate")
                                },
                                model: {
                                  value: _vm.selectedDateRange,
                                  callback: function($$v) {
                                    _vm.selectedDateRange = $$v
                                  },
                                  expression: "selectedDateRange"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showFilters && _vm.selectedDateRange === "calendar"
                    ? _c(
                        "v-layout",
                        {
                          staticClass: "mb-3",
                          attrs: { row: "", wrap: "", "justify-end": "" }
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md2: "" } },
                            [
                              _c(
                                "v-menu",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "min-width": "290px"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-text-field",
                                              _vm._g(
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "filterstart"
                                                    ),
                                                    "prepend-icon": "event",
                                                    readonly: "",
                                                    clearable: ""
                                                  },
                                                  on: {
                                                    "click:clear": function(
                                                      $event
                                                    ) {
                                                      _vm.calendarStartDate = ""
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.calendarStartDate,
                                                    callback: function($$v) {
                                                      _vm.calendarStartDate = $$v
                                                    },
                                                    expression:
                                                      "calendarStartDate"
                                                  }
                                                },
                                                on
                                              )
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3873987087
                                  ),
                                  model: {
                                    value: _vm.showStartDateMenu,
                                    callback: function($$v) {
                                      _vm.showStartDateMenu = $$v
                                    },
                                    expression: "showStartDateMenu"
                                  }
                                },
                                [
                                  _vm._v(" "),
                                  _c("v-date-picker", {
                                    on: {
                                      input: function($event) {
                                        _vm.showStartDateMenu = false
                                      }
                                    },
                                    model: {
                                      value: _vm.calendarStartDate,
                                      callback: function($$v) {
                                        _vm.calendarStartDate = $$v
                                      },
                                      expression: "calendarStartDate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md2: "" } },
                            [
                              _c(
                                "v-menu",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "min-width": "290px"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-text-field",
                                              _vm._g(
                                                {
                                                  attrs: {
                                                    label: _vm.$t("filterend"),
                                                    "prepend-icon": "event",
                                                    readonly: "",
                                                    clearable: ""
                                                  },
                                                  on: {
                                                    "click:clear": function(
                                                      $event
                                                    ) {
                                                      _vm.calendarEndDate = ""
                                                    }
                                                  },
                                                  model: {
                                                    value: _vm.calendarEndDate,
                                                    callback: function($$v) {
                                                      _vm.calendarEndDate = $$v
                                                    },
                                                    expression:
                                                      "calendarEndDate"
                                                  }
                                                },
                                                on
                                              )
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    2332159360
                                  ),
                                  model: {
                                    value: _vm.showEndDateMenu,
                                    callback: function($$v) {
                                      _vm.showEndDateMenu = $$v
                                    },
                                    expression: "showEndDateMenu"
                                  }
                                },
                                [
                                  _vm._v(" "),
                                  _c("v-date-picker", {
                                    on: {
                                      input: function($event) {
                                        _vm.showEndDateMenu = false
                                      }
                                    },
                                    model: {
                                      value: _vm.calendarEndDate,
                                      callback: function($$v) {
                                        _vm.calendarEndDate = $$v
                                      },
                                      expression: "calendarEndDate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "table-scroll-area" },
                    [
                      _c("v-data-table", {
                        staticClass: "elevation-1",
                        attrs: {
                          headers: _vm.headersFAQ,
                          items: _vm.filteredPrompts,
                          pagination: _vm.tablePagination,
                          "must-sort": true,
                          "item-key": "index",
                          loading: _vm.loadingData,
                          "rows-per-page-items": [10, 25, 50]
                        },
                        on: {
                          "update:pagination": function($event) {
                            _vm.tablePagination = $event
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "progress",
                            fn: function() {
                              return [
                                _c("v-progress-linear", {
                                  attrs: { color: "blue", indeterminate: "" }
                                })
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "items",
                            fn: function(props) {
                              return [
                                _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-xs-left date-col",
                                      attrs: { title: props.item.date || "" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.openDialogUpdateFAQ(
                                            props.item
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(props.item.date))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-xs-left",
                                      attrs: { title: props.item.name || "" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.openDialogUpdateFAQ(
                                            props.item
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(props.item.name))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-xs-left",
                                      attrs: {
                                        title: props.item.comment || ""
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.openDialogUpdateFAQ(
                                            props.item
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(props.item.comment))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-xs-left email-col",
                                      attrs: { title: props.item.who || "" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.openDialogUpdateFAQ(
                                            props.item
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(props.item.who))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-xs-left llm-col",
                                      attrs: { title: props.item.llm || "" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.openDialogUpdateFAQ(
                                            props.item
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(props.item.llm))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-xs-left short-num-col",
                                      attrs: {
                                        title: String(
                                          props.item.temperature || ""
                                        )
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.openDialogUpdateFAQ(
                                            props.item
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(props.item.temperature))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-xs-left token-col",
                                      attrs: {
                                        title: String(props.item.tokens || "")
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.openDialogUpdateFAQ(
                                            props.item
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(props.item.tokens))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-xs-left truncate-text",
                                      attrs: {
                                        title: props.item.preview || ""
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.openDialogUpdateFAQ(
                                            props.item
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(props.item.preview))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "text-xs-right action-col" },
                                    [
                                      _c(
                                        "v-tooltip",
                                        { attrs: { left: "" } },
                                        [
                                          _c(
                                            "template",
                                            { slot: "activator" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "infos",
                                                  attrs: {
                                                    color: "black lighten-1",
                                                    dark: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.openDialogUpdateFAQ(
                                                        props.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("more_vert")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.$t("AIVoir")))
                                          ])
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "text-xs-right action-col" },
                                    [
                                      _c(
                                        "v-tooltip",
                                        { attrs: { left: "" } },
                                        [
                                          _c(
                                            "template",
                                            { slot: "activator" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "infos",
                                                  attrs: {
                                                    color: "black lighten-1",
                                                    dark: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      _vm.selectedPromptVersion =
                                                        props.item
                                                      _vm.renamePromptName =
                                                        props.item &&
                                                        props.item.name
                                                          ? props.item.name
                                                          : ""
                                                      _vm.renamePromptComment =
                                                        props.item &&
                                                        props.item.comment
                                                          ? props.item.comment
                                                          : ""
                                                      _vm.showDialogRename = true
                                                    }
                                                  }
                                                },
                                                [_vm._v("edit")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.$t("rename")))
                                          ])
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "text-xs-right action-col" },
                                    [
                                      _c(
                                        "v-tooltip",
                                        { attrs: { left: "" } },
                                        [
                                          _c(
                                            "template",
                                            { slot: "activator" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    color: _vm.canDeleteVersion(
                                                      props.item
                                                    )
                                                      ? "black lighten-1"
                                                      : "grey lighten-1"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.openConfirmDeleteDialogFromRow(
                                                        props.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("delete")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.canDeleteVersion(props.item)
                                                  ? _vm.$t("delete")
                                                  : _vm.$t("undeletable")
                                              )
                                            )
                                          ])
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.$vuetify.breakpoint.smAndDown &&
      !_vm.closeDialogUniquement &&
      !_vm.modifBaseCo
        ? _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              !_vm.loadingModifFAQ
                ? _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.closeDialogConfirm()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("no")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    loading: _vm.loadingModifFAQ,
                    disabled: !_vm.selectActionPrompt.length,
                    color: "primary"
                  },
                  on: {
                    click: function($event) {
                      return _vm.submitDialogConfirm()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        : !_vm.$vuetify.breakpoint.smAndDown &&
          !_vm.closeDialogUniquement &&
          _vm.modifBaseCo
        ? _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("justCloseDialogConfirm")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("close")))]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("closeDialogConfirm")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("ok")))]
              )
            ],
            1
          )
        : _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.closeDialogConfirm()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("close")))]
              )
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "90%" },
          model: {
            value: _vm.showDialogComparePrompt,
            callback: function($$v) {
              _vm.showDialogComparePrompt = $$v
            },
            expression: "showDialogComparePrompt"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text compare-title" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: { click: _vm.closeCompareDialog }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "title compare-title-text" }, [
                    _vm._v(_vm._s(_vm.$t("compareprompt")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "compare-body" },
                [
                  _c("div", { staticClass: "mb-3" }, [
                    _c("strong", [_vm._v(_vm._s(_vm.$t("sectionprompt")))]),
                    _vm._v(
                      " " + _vm._s(_vm.selectedPromptField()) + "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        {
                          staticClass: "pr-3 compare-col",
                          attrs: { xs12: "", md6: "" }
                        },
                        [
                          _c("h3", { staticClass: "mb-2 compare-label" }, [
                            _vm._v(_vm._s(_vm.$t("currentprompt")))
                          ]),
                          _vm._v(" "),
                          _c("v-textarea", {
                            attrs: {
                              value: _vm.getCurrentPromptValue(),
                              readonly: "",
                              "auto-grow": "",
                              rows: "12",
                              outline: ""
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "compare-meta" }, [
                            _c("div", [
                              _c("strong", [_vm._v("LLM:")]),
                              _vm._v(
                                " " + _vm._s(_vm.getCurrentPromptMeta().llm)
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.$t("Temperatureprompt")))
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getCurrentPromptMeta().temperature)
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("strong", [_vm._v("Tokens:")]),
                              _vm._v(
                                " " + _vm._s(_vm.getCurrentPromptMeta().tokens)
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.$t("Nameprompt")))
                              ]),
                              _vm._v(
                                " " + _vm._s(_vm.getCurrentPromptMeta().name)
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.$t("Commentprompt")))
                              ]),
                              _vm._v(
                                " " + _vm._s(_vm.getCurrentPromptMeta().comment)
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        {
                          staticClass: "pl-3 compare-col",
                          attrs: { xs12: "", md6: "" }
                        },
                        [
                          _c("h3", { staticClass: "mb-2 compare-label" }, [
                            _vm._v(_vm._s(_vm.$t("historyprompt")))
                          ]),
                          _vm._v(" "),
                          _c("v-textarea", {
                            attrs: {
                              value: _vm.getHistoricPromptValue(),
                              readonly: "",
                              "auto-grow": "",
                              rows: "12",
                              outline: ""
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "compare-meta" }, [
                            _c("div", [
                              _c("strong", [_vm._v("LLM:")]),
                              _vm._v(
                                " " + _vm._s(_vm.getHistoricPromptMeta().llm)
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.$t("Temperatureprompt")))
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getHistoricPromptMeta().temperature
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("strong", [_vm._v("Tokens:")]),
                              _vm._v(
                                " " + _vm._s(_vm.getHistoricPromptMeta().tokens)
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.$t("Nameprompt")))
                              ]),
                              _vm._v(
                                " " + _vm._s(_vm.getHistoricPromptMeta().name)
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.$t("Commentprompt")))
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getHistoricPromptMeta().comment)
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: { click: _vm.closeCompareDialog }
                    },
                    [_vm._v(_vm._s(_vm.$t("close")))]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "error",
                        disabled: !_vm.canDeleteSelectedVersion()
                      },
                      on: { click: _vm.openConfirmDeleteDialog }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("deleteprompt")) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "warning",
                        disabled:
                          _vm.selectedPromptField() === "preview" ||
                          !_vm.selectedPromptVersion
                      },
                      on: { click: _vm.openConfirmRestoreDialog }
                    },
                    [
                      _vm._v(
                        "\n               " +
                          _vm._s(_vm.$t("restoreprompt")) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "warning",
                        outline: "",
                        disabled: !_vm.selectedPromptVersion
                      },
                      on: {
                        click: function($event) {
                          return _vm.openConfirmRestoreDialog(true)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n              Restaurer toutes les sections\n            "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "560" },
          model: {
            value: _vm.showDialogConfirmRestore,
            callback: function($$v) {
              _vm.showDialogConfirmRestore = $$v
            },
            expression: "showDialogConfirmRestore"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(_vm._s(_vm.$t("erasedprompt")))
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _vm.restoreAllMode
                    ? [
                        _vm._v(
                          "\n              Le prompt actuel (toutes les sections) sera remplacé par cette version historisée.\n              "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("proceed")) +
                            "\n            "
                        )
                      ]
                    : [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("actualprompt")) +
                            " "
                        ),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.selectedPromptField()))
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("erasedprompt")) +
                            ".\n              "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("proceed")) +
                            "\n            "
                        )
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.showDialogConfirmRestore = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "warning" },
                      on: { click: _vm.confirmRestorePrompt }
                    },
                    [_vm._v(_vm._s(_vm.$t("confirm")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "560" },
          model: {
            value: _vm.showDialogConfirmDelete,
            callback: function($$v) {
              _vm.showDialogConfirmDelete = $$v
            },
            expression: "showDialogConfirmDelete"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(_vm._s(_vm.$t("confirmation")))
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("definitlyprompt")) +
                    "\n            "
                ),
                _c("br"),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("proceedprompt")) +
                    "\n          "
                )
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.showDialogConfirmDelete = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "error",
                        loading: _vm.loadingDeleteVersion
                      },
                      on: { click: _vm.confirmDeleteVersion }
                    },
                    [_vm._v(_vm._s(_vm.$t("Delete")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "560" },
          model: {
            value: _vm.showDialogRename,
            callback: function($$v) {
              _vm.showDialogRename = $$v
            },
            expression: "showDialogRename"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(_vm._s(_vm.$t("editcomment")))
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("Name"),
                      maxlength: "255",
                      counter: ""
                    },
                    model: {
                      value: _vm.renamePromptName,
                      callback: function($$v) {
                        _vm.renamePromptName = $$v
                      },
                      expression: "renamePromptName"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("abscomment"),
                      maxlength: "255",
                      counter: ""
                    },
                    model: {
                      value: _vm.renamePromptComment,
                      callback: function($$v) {
                        _vm.renamePromptComment = $$v
                      },
                      expression: "renamePromptComment"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.showDialogRename = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        loading: _vm.loadingRenameVersion
                      },
                      on: { click: _vm.confirmRenameVersion }
                    },
                    [_vm._v(_vm._s(_vm.$t("Submit")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a67fd020", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a67fd020","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzDialogVersionPrompt.vue
// module id = null
// module chunks = 